export const MAP_LOADED_SCRIPT_TRUE = 'MAP_LOADED_SCRIPT_TRUE';
export const MAP_LOADED_SCRIPT_FALSE = 'MAP_LOADED_SCRIPT_FALSE';